import * as React from 'react';
import { SVGProps } from 'react';

const SvgReferral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M36.125 30.602H7.963V11.555h28.162v19.047Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M7.875 30.55H5.896L3 13.55h5"
    />
    <path
      fill="currentColor"
      d="m28.406 20.873-5.269-3.871v8.218l5.277-4.347h-.008Z"
    />
    <path fill="currentColor" d="M24.67 19.59h-8.219v3.083h8.22V19.59Z" />
    <path fill={props.fill} d="M7.213 12.86V8.77l8.22-.02 4.109 4.11H7.213Z" />
  </svg>
);

export default SvgReferral;
